import assetPath from '/app/packages/lebenslauf/articles/src/assets/praktikumsbericht.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')